"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionTypes = _interopRequireDefault(require("redux-less/constants/ActionTypes"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _getNestedPropertiesAsStrings = _interopRequireDefault(require("redux-less/utils/getNestedPropertiesAsStrings"));

var createSimpleChangePropertyActionType = function createSimpleChangePropertyActionType(objectTypeStr, namespaceStr, property) {
  return (0, _defineProperty2.default)({}, property, "" + namespaceStr + _ActionTypes.default.CHANGE_PROPERTY + "/" + objectTypeStr + property);
};

var createOrderedMapChangePropertyActionTypes = function createOrderedMapChangePropertyActionTypes(objectTypeStr, namespaceStr, property) {
  var _ref2;

  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, property.key + "/" + _ActionTypes.default.ADD_TO_MAP, "" + namespaceStr + _ActionTypes.default.ADD_TO_MAP + "/" + objectTypeStr + property.key), (0, _defineProperty2.default)(_ref2, property.key + "/" + _ActionTypes.default.REMOVE_FROM_MAP, "" + namespaceStr + _ActionTypes.default.REMOVE_FROM_MAP + "/" + objectTypeStr + property.key), (0, _defineProperty2.default)(_ref2, property.key + "/" + _ActionTypes.default.REORDER_MAP, "" + namespaceStr + _ActionTypes.default.REORDER_MAP + "/" + objectTypeStr + property.key), _ref2;
};

var createNestedChangePropertyActionTypes = function createNestedChangePropertyActionTypes(objectTypeStr, namespaceStr, property) {
  var nestedPropertiesAsStrings = (0, _getNestedPropertiesAsStrings.default)(property);
  return nestedPropertiesAsStrings.reduce(function (acc, prop) {
    return Object.assign({}, acc, (0, _defineProperty2.default)({}, prop, "" + namespaceStr + _ActionTypes.default.CHANGE_PROPERTY + "/" + objectTypeStr + prop));
  }, {});
};

var _default = function _default(_ref3) {
  var properties = _ref3.properties,
      _ref3$objectType = _ref3.objectType,
      objectType = _ref3$objectType === void 0 ? "" : _ref3$objectType,
      _ref3$namespace = _ref3.namespace,
      namespace = _ref3$namespace === void 0 ? "" : _ref3$namespace;
  var namespaceStr = namespace && namespace.length ? namespace + "/" : "";
  var objectTypeStr = objectType && objectType.length ? objectType + "/" : "";
  return properties.reduce(function (acc, property) {
    if (typeof property === "string") {
      return Object.assign({}, acc, createSimpleChangePropertyActionType(objectTypeStr, namespaceStr, property));
    } else if ((0, _typeof2.default)(property) === "object" && property.type) {
      if (property.type === _PropertyTypes.default.SIMPLE) {
        return Object.assign({}, acc, createSimpleChangePropertyActionType(objectTypeStr, namespaceStr, property.key));
      } else if (property.type === _PropertyTypes.default.NESTED) {
        return Object.assign({}, acc, createNestedChangePropertyActionTypes(objectTypeStr, namespaceStr, property));
      } else if (property.type === _PropertyTypes.default.ORDERED_MAP) {
        return Object.assign({}, acc, createOrderedMapChangePropertyActionTypes(objectTypeStr, namespaceStr, property));
      }
    }

    return acc;
  }, {});
};

exports.default = _default;
module.exports = exports.default;